import { MouseEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { AnalyticsStructureStore } from 'core/stores/analytics-structure.store';
import { ButtonMetadata, ButtonType, CircleButtonSize } from '../button-types';
import styles from './circle-action-button.module.scss';

export const CircleActionButton = observer(({
  meta,
  classes,
  onClick,
  analyticsComponentName = "button"
}: {
  meta: ButtonMetadata,
  classes?: string[],
  onClick?: (e: MouseEvent) => void,
  analyticsComponentName?: string
}) => {
  const overWriteKeys = {
    'buttonCta': (meta?.iconName),
    'areaName': meta?.areaName
  }
  const analyticsTags = (meta: ButtonMetadata) => {
    return {
      "data-component-name": `${meta.areaName}`,
      "data-component-info": JSON.stringify(AnalyticsStructureStore.getComponentAnalyticsAsJson(analyticsComponentName, overWriteKeys))
      // "data-component-info": `{
      //   'name': '${meta.name}',
      //   'componentName': '${meta.componentName}',
      //   'targetPageUrl': '${meta.targetUrl}',
      //   'text': '${meta.title}'
      //}`
    };
  }

  return (
    <div className={`${[...(classes || [])].join(' ')}`}>
      <div className={`${styles['circle-icon']} ${styles[meta.size || CircleButtonSize.Medium]} ${(meta.type ? styles[meta.type] : styles[ButtonType.Primary])}`}>
        <button
          className={[styles.btn, 'btn', meta.type ? styles[meta.type] : styles[ButtonType.Primary], meta.outline ? styles.outline : null].join(' ')}
          onClick={onClick}
          {...analyticsTags(meta)}
        >
          <i className={meta.iconName}></i>
        </button>
      </div>
    </div>
  )
})